





















import {Vue, Component} from 'vue-property-decorator';
import ReviewInfo from '@/components/product/review/ReviewInfo.vue';

import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';

@Component({
  components: {ReviewInfo}
})
export default class ReviewDetail extends Vue {
  private initOver = false;
  private reviewInfo: any = {
    reviewDetail: {},
    reason: ''
  };

  // 저장
  private async save() {
    let request = {
      pathParams: {
        reviewNo: this.$route.params.reviewNo
      },
      data: {
        reason: this.reviewInfo.reason,
        bestReviewYn: this.reviewInfo.reviewDetail.bestReviewYn,
        displayStatusType: this.reviewInfo.reviewDetail.displayStatusType
      }
    };
    await this.$api.putReviewsReviewNo(request);

    let pageFrom = sessionStorage.getItem('reviewDetailFrom');
    alert(this.$t('PRODUCT_REVIEW_SAVE_MSG'));
    if (pageFrom === 'ReviewList') {
      $(window.opener.location).attr('href', 'javascript:window.detailCallBack();');
    }
    window.close();
  }

  // 취소
  private close() {
    window.close();
  }

  private async mounted() {
    addClass(document.body, 'popup_large');
    let request: any = {
      pathParams: {
        reviewNo: this.$route.params.reviewNo
      }
    };
    let {data} = await this.$api.getReviewsReviewNo(request);
    this.reviewInfo.reviewDetail = data;

    this.initOver = true;
    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_large');
  }
}
